import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Box,
    TextField,
    MenuItem,
    Button,
    FormControlLabel,
    Switch,
    Typography,
    Checkbox
} from '@mui/material';
import axios from 'axios';
import apiUrl from '../../Config';
import Context from '../../context/Context';
import { toast } from 'react-toastify';

const AddEditEmployee = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const employee = location.state;
    const { roles, getAllRoles } = useContext(Context);

    const [form, setForm] = useState({
        name: '',
        email: '',
        mobile: '',
        password: '',
        roleId: '',
        isActive: true,
        isDeleted: false,
    });
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        getAllRoles();

        if (employee) {
            setForm({
                name: employee.name || '',
                email: employee.email || '',
                mobile: employee.mobile || '',
                password: '',
                roleId: employee.roleId || '',
                isActive: employee.isActive,
                isDeleted: employee.isDeleted || false,
            });
        }
    }, [employee]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const payload = {
            name: form.name,
            email: form.email,
            mobile: form.mobile,
            ...(form.password && { password: form.password }),
            roleId: form.roleId,
            isActive: form.isActive,
            isDeleted: form.isDeleted
        };

        try {
            let response;
            if (employee) {
                response = await axios.put(`${apiUrl}/employee/updateemployee/${employee.id}`, payload);
            } else {
                response = await axios.post(`${apiUrl}/employee/employee`, payload);
            }
            if (response.data.status === true) {
                toast.success(response.data.message);
                navigate('/display-employees');
            }

        } catch (err) {
            console.error('Submission error:', err);
            // TODO: show user-friendly error feedback
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box maxWidth={500} mr="auto" m={2} sx={{ border: '1px solid lightgrey', borderRadius: '5px' }}>
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" mb={2}>
                    {employee ? 'Edit Employee' : 'Add New Employee'}
                </Typography>

                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        name="name"
                        label="Name"
                        margin="normal"
                        value={form.name}
                        onChange={handleChange}
                        required
                        size='small'
                    />
                    <TextField
                        fullWidth
                        name="email"
                        label="Email"
                        margin="normal"
                        type="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        size='small'
                    />
                    <TextField
                        fullWidth
                        name="mobile"
                        label="Mobile"
                        margin="normal"
                        value={form.mobile}
                        onChange={handleChange}
                        required
                        size='small'
                    />
                    <TextField
                        fullWidth
                        name="password"
                        label="Password"
                        margin="normal"
                        type="password"
                        value={form.password}
                        helperText={employee ? 'Leave blank to keep current password' : ''}
                        onChange={handleChange}
                        required={!employee}
                        size='small'
                    />
                    <TextField
                        select
                        fullWidth
                        name="roleId"
                        label="Role"
                        margin="normal"
                        value={form.roleId}
                        onChange={handleChange}
                        required
                        size='small'
                    >
                        {roles && roles.length > 0 ? (
                            roles.map((role) => (
                                <MenuItem key={role.id} value={role.id}>
                                    {role.name}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem value="" disabled>
                                No roles available
                            </MenuItem>
                        )}
                    </TextField>

                    <FormControlLabel
                        control={
                            <Checkbox
                                name="isActive"
                                checked={form.isActive}
                                onChange={handleChange}
                            />
                        }
                        label="Is Active"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                name="isDeleted"
                                checked={form.isDeleted}
                                onChange={handleChange}
                            />
                        }
                        label="Is Deleted"
                    />

                    <Box mt={3} display="flex" justifyContent="space-between">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={submitting}
                        >
                            {employee ? 'Update' : 'Create'}
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/display-employees')}
                            disabled={submitting}
                        >
                            Cancel
                        </Button>
                    </Box>
                </form>
            </Box>
        </Box>
    );
};

export default AddEditEmployee;
